import type { CollapseProps } from 'aui';
import { Collapse } from 'aui';
import React from 'react';

export type CollapseNoDefaultMotionProps = CollapseProps;

export function CollapseNoDefaultMotion(props: CollapseNoDefaultMotionProps) {
  const [openMotion, setOpenMotion] = React.useState<boolean>(false);

  React.useEffect(() => {
    setOpenMotion(true);
  }, []);

  const newProps = React.useMemo(() => {
    const result: CollapseProps & { openMotion?: boolean } = { ...props };
    if (!openMotion) {
      result.openMotion = false;
    }

    return result;
  }, [props, openMotion]);

  return <Collapse {...newProps} />;
}
